import React from 'react';

export default class ArticleImage extends React.Component {

  render() {
    return this.props.article.gallery_images[0] ? <img className="article_image" alt={this.props.article.slug} src={this.props.apiRoot + this.props.article.gallery_images[0].image.small.url} /> : null
  }
}
